import styled from 'styled-components'
import header from './images/header.svg'
import headerDark from './images/headerDark.svg'
import headerMobile from './images/headerMobile.svg'
import headerMobileDark from './images/headerMobileDark.svg'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { useState } from 'react'
import { useEffectOnce } from 'usehooks-ts'

const Header = ({
  tenant,
  colorMode,
  title,
  lead,
  pubDate,
}: {
  tenant: Tenant
  colorMode: 'light' | 'dark' | undefined
  title?: string
  lead?: string
  pubDate?: string
}) => {
  const [hasHeader, setHasHeader] = useState(false)
  const [isMobile, setIsMobile] = useState(true)
  const [isWide, setIsWide] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
    setIsWide(
      window.innerWidth >= 1360 || window.innerWidth > window.innerHeight
    )
  }

  useEffectOnce(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')
    if (headerElement) {
      setHasHeader(true)
    }
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <HeaderContainer>
      {/* <img
        src={require(colorMode == 'dark'
          ? './mittelstand_header_dm.gif'
          : './mittelstand_header.gif')}
      /> */}
      {/* <img src={require('./mittelstand_header_2.gif')} className='ddd'/> */}
      <div className='header-image'>
        <img
          src={
            colorMode === 'dark'
              ? isMobile
                ? headerMobileDark
                : headerDark
              : isMobile
              ? headerMobile
              : header
          }
          alt='header'
        />
      </div>

      <ContentContainer>
        <TextWidthExtended>
          <h2>{title}</h2>
          <h3>{lead}</h3>
          <Authors colorMode={colorMode}>
            <span key={83371228}>
              <a
                href={
                  tenant && tenant.key
                    ? `https://www.${
                        tenant.key
                      }.ch/author/${83371228}/marc-brupbacher`
                    : ''
                }
                style={{ background: 'none' }}
              >
                Marc Brupbacher
              </a>
            </span>
            <span key={38525508}>
              <a
                href={
                  tenant && tenant.key
                    ? `https://www.${
                        tenant.key
                      }.ch/author/${38525508}/svenson-cornehls`
                    : ''
                }
                style={{ background: 'none' }}
              >
                Svenson Cornehls
              </a>
            </span>
            <span key={65386355}>
              <a
                href={
                  tenant && tenant.key
                    ? `https://www.${
                        tenant.key
                      }.ch/author/${65386355}/patrick-vogeli`
                    : ''
                }
                style={{ background: 'none' }}
              >
                Patrick Vögeli
              </a>
            </span>
          </Authors>
          <Publication colorMode={colorMode}>{pubDate}</Publication>
        </TextWidthExtended>
      </ContentContainer>
    </HeaderContainer>
  )
}

const ContentContainer = styled.div`
  background-color: transparent;
  overflow: hidden;
  position: relative;
  /* max-width: 900px;

  @media only screen and (max-width: 1023px) {
    max-width: 668px;
  }
  @media only screen and (max-width: 711px) {
    max-width: 500px;
  }
  @media only screen and (max-width: 540px) {
    padding-left: 2rem;
    padding-right: 2rem;
  } */
  margin: 0 auto;
`
const HeaderContainer = styled.div`
  position: relative;
  /* border-bottom: 3px solid var(--text-color); */
  overflow: hidden;
  /* margin-bottom: 80px; */
  color: var(--text-color);

  .header-image {
    /* background-color: var(--site-background); */
    position: relative;
    text-align: center;
    img,
    video {
      width: 90%;
      max-width: 1072px;
      text-align: center;
      @media only screen and (max-width: 1679px) {
        max-width: 1016px;
      }
      @media only screen and (max-width: 1023px) {
        max-width: 784px;
      }
      @media only screen and (max-width: 711px) {
        max-width: 500px;
      }
    }

    /* img {
    transform: scale(0.8);
    position: absolute;
    top: 0;
    bottom: -100px;
    left: 0;
    width: 100%;

    &.ddd {
      z-index: 20;
    } */
  }
  h2 {
    font-size: 44px;
    line-height: 48px;
    text-align: center;
    /* max-width: 500px;
    padding: 30px 15px;
    margin-left: auto;
    margin-right: auto; */
    /* font-family: var(--font-serif); */
  }

  h3 {
    width: 100%;
    font-weight: 300;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
  }
  @media screen and (max-width: 712px) {
    img {
      display: inline-block;
    }
    h2 {
      font-size: 33px;
      line-height: 38px;
    }
    h3 {
      font-size: 18px;
      line-height: 27px;
    }
  }
`

const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: 100%;
  text-align: center;

  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  /* border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'}; */
  /* padding-top: 2rem; */

  button {
    &:hover {
      cursor: pointer;
    }
    padding: 0;
    border: 0;
    background-color: transparent;
  }
  a,
  button {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span {
    white-space: nowrap;
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
const Publication = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  margin-bottom: 60px;
  flex: 0 0 100%;
  text-align: center;
`
export default Header
